var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124",
    transform: "translate(-1813.992 -83.067)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(1815.492 84.567)",
    fill: "none",
    stroke: "#041f4f",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1.3-11.066q.616,0,.616.858v6.622q0,1.122.418,1.122a1.662,1.662,0,0,0,.319-.055,1.722,1.722,0,0,1,.385-.055q.924,0,.924,1.144,0,1.518-1.3,1.518-.22,0-1.232-.11A13.353,13.353,0,0,0,.022-.088,11.176,11.176,0,0,0-1.144,0,11.13,11.13,0,0,1-2.288.088a1.254,1.254,0,0,1-.968-.407A1.484,1.484,0,0,1-3.63-1.364q0-1.254,1.056-1.254L-2-2.486a.646.646,0,0,0,.154.022q.4,0,.4-1.232V-7.26q0-1.254-.374-1.254a2.111,2.111,0,0,0-.4.11,1.893,1.893,0,0,1-.352.044q-1.056,0-1.056-1.232a1.515,1.515,0,0,1,.374-1.067,1.28,1.28,0,0,1,.99-.407,5.4,5.4,0,0,1,.7.066,9.167,9.167,0,0,0,1.232.11,6.889,6.889,0,0,0,.968-.088Q1.232-11.066,1.3-11.066ZM.044-11.9A1.924,1.924,0,0,1-1.364-12.5,1.924,1.924,0,0,1-1.958-13.9a1.931,1.931,0,0,1,.583-1.419,1.931,1.931,0,0,1,1.419-.583,1.931,1.931,0,0,1,1.419.583A1.931,1.931,0,0,1,2.046-13.9a1.931,1.931,0,0,1-.583,1.419A1.931,1.931,0,0,1,.044-11.9Z",
    transform: "translate(1827.622 103.973)",
    fill: "#041f4f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconI);
export default __webpack_public_path__ + "static/media/icon-i.50c6d3b821c23bfde8ca352244faa4ad.svg";
export { ForwardRef as ReactComponent };